import { BaseConfirmationDialog } from '@/features/dialog/confirmation-dialog';
import { DialogStateManager, useDialog } from '@/features/dialog/dialog-provider';
import { useLocale } from '@/lib/hooks/use-locale';
import type { CrmNoteDTO } from '@/server/dto/crm-note-dto';
import { InfoIcon } from 'lucide-react';

export type NotePinConfirmationDialogProps = {
    note: CrmNoteDTO;
    onConfirm: () => void;
};

export const NotePinConfirmationDialog = DialogStateManager.create<NotePinConfirmationDialogProps>(
    ({ onConfirm }) => {
        const { remove } = useDialog();
        const { t } = useLocale('notes');

        return (
            <BaseConfirmationDialog
                focus="destroy"
                icon={InfoIcon}
                title={t('notes__pin_confirmation_title')}
                description={t('notes__pin_confirmation_description')}
            >
                <BaseConfirmationDialog.Actions>
                    <BaseConfirmationDialog.RejectButton onClick={remove}>
                        {t('notes__pin_confirmation_cancel')}
                    </BaseConfirmationDialog.RejectButton>
                    <BaseConfirmationDialog.AcceptButton
                        onClick={() => {
                            onConfirm();
                            remove();
                        }}
                    >
                        {t('notes__pin_confirmation_confirm')}
                    </BaseConfirmationDialog.AcceptButton>
                </BaseConfirmationDialog.Actions>
            </BaseConfirmationDialog>
        );
    },
);
